import React, { useMemo } from 'react'
import _ from 'lodash'
import { formFieldsDefaultProps, formFieldsPropTypes } from './propTypes'
import FormField from './FormField'

const FormFields = ({
  fields,
  fieldComponents,
  ContainerComponent,
  onFocusField,
  onBlurField,
  onDisableField,
  onEnableField,
  onSetFieldErrors,
  onSetFieldValue,
  onSetGlobalErrors,
  onSetIsLoading,
  onSubmit,
  globalErrors,
  isLoading
}) => {
  const renderFields = useMemo(() => {
    return _.chain(fields)
      .map((field) => {
        const { component, key } = field
        const Component = _.isString(component)
          ? fieldComponents[component]
          : component

        if (!Component) {
          return null
        }

        return (
          <FormField
            key={key}
            field={field}
            Component={Component}
            onFocusField={onFocusField}
            onBlurField={onBlurField}
            onDisableField={onDisableField}
            onEnableField={onEnableField}
            onSetFieldValue={onSetFieldValue}
            fields={fields}
          />
        )
      })
      .filter(_.identity)
      .sortBy('number')
      .value()
  }, [
    fields,
    onFocusField,
    onBlurField,
    onDisableField,
    onEnableField,
    onSetFieldValue,
    fieldComponents
  ])

  return (
    <ContainerComponent
      fields={fields}
      onFocusField={onFocusField}
      onBlurField={onBlurField}
      onDisableField={onDisableField}
      onEnableField={onEnableField}
      onSetFieldErrors={onSetFieldErrors}
      onSetFieldValue={onSetFieldValue}
      onSetGlobalErrors={onSetGlobalErrors}
      onSetIsLoading={onSetIsLoading}
      onSubmit={onSubmit}
      globalErrors={globalErrors}
      isLoading={isLoading}
    >
      {renderFields}
    </ContainerComponent>
  )
}

FormFields.defaultProps = formFieldsDefaultProps
FormFields.propTypes = formFieldsPropTypes

export default FormFields
